import React from 'react'

const Banner = () => {
    return (
       <React.Fragment>
           
    <div className="container mt-3">

<div className="jumbotron">
    <h1 className="display-4">Welcome to Riyaz Stationary</h1>
    <p className="lead">We provide all engineering Students books and as well compiteve exam like UPSC , MPSC , Railway , Police Bharti , Banks, JEE NEET and CET.</p>
    <hr className="my-4"/>
    <p>It uses utility classNamees for typography and spacing to space content out within the larger container.</p>
    <p className="lead">
        <a className="btn btn-success btn-lg" href="#" role="button">View on google map</a>
    </p>
</div>



</div>
       </React.Fragment>
    )
}

export default Banner
